export default "__VITE_ASSET__VMuUHSCq__"